import { Skeleton } from "@nabble/ui";

const PLACEHOLDER_CARDS = [0, 1];

/** Placeholder cards while the policies load. */
export function PoliciesSkeleton(): React.JSX.Element {
  return (
    <div className="nb-stack-lg" style={{ maxWidth: 960 }}>
      {PLACEHOLDER_CARDS.map((i) => (
        <div key={i} className="nb-card nb-card-pad nb-stack">
          <Skeleton width="30%" height={16} />
          <Skeleton width="60%" height={12} />
          <Skeleton height={40} radius={10} />
        </div>
      ))}
    </div>
  );
}
